import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  getLoginFormError,
  performAnonymousUserLogin,
  performEmailPasswordUserLogin,
  setLoginFormError,
  setShowLoginForm,
  displayCreateAccountForm,
  showLoginForm,
} from 'components/user/userSlice';
import { DialogButton } from '@rmwc/dialog';
import { Button } from '@rmwc/button';
import { Typography } from '@rmwc/typography';
import BaseDialog from '../BaseDialog';
import BaseInputField from 'components/inputfield/BaseInputField';

import styles from './LoginDialog.module.scss';

const LoginDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(showLoginForm);
  const errorText = useAppSelector(getLoginFormError);
  const onSetOpen = (shouldOpen: boolean) => dispatch(setShowLoginForm(shouldOpen));
  // console.log(`show dialog = ${isOpen}`);
  const [username, setUsernameField] = useState<string>('');
  const [password, setPasswordField] = useState<string>('');

  const setUsername = (val: string) => setUsernameField(val.trim());
  const setPassword = (val: string) => setPasswordField(val.trim());

  const resetFields = () => {
    setUsernameField('');
    setPasswordField('');
    dispatch(setLoginFormError(''));
  };

  const actionHandler = (actionName: string) => {
    if (actionName === 'login') {
      dispatch(performEmailPasswordUserLogin(username, password));
    } else if (actionName === 'anonymous') {
      dispatch(performAnonymousUserLogin());
    }
  };

  const createAccountHandler = () => dispatch(displayCreateAccountForm());

  const dialogContent = (
    <div className={styles.LoginDialogContent}>
      <BaseInputField
        id={'loginEmailId'}
        type={'text'}
        label={'Email'}
        value={username.trim()}
        onChange={setUsername}
      />
      <BaseInputField
        id={'loginPwdId'}
        type={'password'}
        label={'Password'}
        value={password.trim()}
        onChange={setPassword}
      />
      <Typography className={styles.LoginDialogError} tag="div" use="body2">
        {errorText}
      </Typography>

      <div className={styles.LoginDialogSecondaryButtons}>
        <Button theme="onSecondary" dense onClick={createAccountHandler} label="Create Account" />
        <Button theme="onSecondary" dense onClick={() => actionHandler('anonymous')} label="Login as guest" />
      </div>
    </div>
  );

  const dialogActions = (
    <div className={styles.LoginDialogActionButtons}>
      <DialogButton theme="secondary" dense action="close" label="Cancel" />
      <DialogButton theme="secondaryBg" raised onClick={() => actionHandler('login')} isDefaultAction label="Login" />
    </div>
  );

  return (
    <BaseDialog
      open={isOpen}
      preventOutsideDismiss={true}
      setOpen={onSetOpen}
      onActionCallback={actionHandler}
      onClosedCallback={resetFields}
      title={'Login'}
      content={dialogContent}
      actions={dialogActions}
    />
  );
};

export default LoginDialog;
